import styled from 'styled-components'

export const SenderTokenSwapper = styled.div`
  width: 50vw;
  margin: 0 auto;
  padding-bottom: 3rem;
  text-align: start;

  input {
    background: #fff;
    &:focus:not(:disabled) {
      box-shadow: 0px 0px 0px 1px #9a84c8, 0px 0px 0px 1px rgb(118 69 217 / 60%);
    }
  }
  .imagetop2 {
    margin: 3rem 0 2rem;
  }
  .flex_sb {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .colorred {
    cursor: pointer;
    color: red;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
export const SenderTokenItem = styled.div`
  width: 100%;
  border-radius: 16px;
  margin-top: 0.5rem;

  .steps {
    width: 60%;
    margin: 0 auto;
  }

  .item {
    display: flex;
    .itemleft {
      flex: 1;
    }
    .itemright {
      margin-left: 1rem;
      width: 15%;
    }
  }

  .updateTitle {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  input:focus:not(:disabled) {
    box-shadow: none;
  }
  .flexcenter {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
  }
  .magrinl1 {
    margin-left: 0.3rem;
  }

  @media (max-width: 768px) {
    width: 98%;
  }
`
